// Gör om ett värde som typmässigt kan vara null/undefined om vi vet att det är definierat
export const assumeDefined = <T>(value?: T): T => {
  if (value == null) {
    throw new Error('undefined value passed to assumeDefined');
  }
  return value;
};

// Kastar ett fel om ett värde är null/undefined
export const definedOrThrow =
  (message: string) =>
  <T>(value?: T): T => {
    if (value == null) {
      throw new Error(message);
    }
    return value;
  };
